import React, { useState, useEffect } from 'react';
import { ThemeProvider, theme, PeekBox, PeekScreenLoader, PeekSnackbar, PeekAlert, PeekTypography } from '@piiqtechnologies/ui-components';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import { ErrorProvider, useError } from '../../../utils/ErrorProvider.js';
import { LoaderProvider, useLoader } from '../../../utils/LoaderProvider.js';
import { RefetchProvider } from '../../../utils/RefetchProvider.js';
import { NotificationProvider, useNotification } from '../../../utils/NotificationProvider.js';
import 'tslib';
import { ContactProvider } from '../../../utils/ContactProvider.js';
import '../../../utils/PolicyProvider.js';
import '../../../utils/AnalyticsProvider.js';
import '@analytics/storage-utils';
import '../../../types/AccessDevice.js';
import '../../../types/Analytics.js';
import '../../../types/CASACommunity.js';
import '../../../types/Community.js';
import '../../../types/DxSettings.js';
import '../../../types/MagicButton.js';
import '../../../types/Pannellum.js';
import '../../../types/Prospect.js';
import '../../../types/ProspectIntelligence.js';
import '../../../types/Space.js';
import '../../../types/Tour.js';
import '../../../utils/analyticsPlugin.js';
import '../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../utils/cookieUtils.js';
import '../../../utils/termsConditionsAgreementsUtils.js';

const Layout = ({ children }) => {
    const { loader } = useLoader();
    const { error, setError } = useError();
    const { notification, setNotification } = useNotification();
    const [vh, setVh] = useState(window.innerHeight * 0.01);
    useEffect(() => {
        const handleResize = () => {
            setVh(window.innerHeight * 0.01);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const handleCloseError = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setError(null);
    };
    const handleCloseNotification = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setNotification(null);
    };
    return (React.createElement(PeekBox, { sx: {
            width: "100%",
            height: `${vh * 100}px`,
            position: "relative",
            overflow: "hidden !important",
        } },
        loader && React.createElement(PeekScreenLoader, { layered: true }),
        children,
        React.createElement(PeekSnackbar, { anchorOrigin: { vertical: "top", horizontal: "right" }, open: !!error, autoHideDuration: 3000, onClose: handleCloseError, sx: { zIndex: 9999 } },
            React.createElement(PeekBox, null,
                React.createElement(PeekAlert, { sx: { alignItems: "center" }, onClose: handleCloseError, severity: "error" },
                    React.createElement(PeekTypography, { variant: "body1" }, error)))),
        React.createElement(PeekSnackbar, { anchorOrigin: { vertical: "top", horizontal: "right" }, open: !!notification, autoHideDuration: 3000, onClose: handleCloseNotification, sx: { zIndex: 99999 } },
            React.createElement(PeekBox, null,
                React.createElement(PeekAlert, { sx: { alignItems: "center" }, onClose: handleCloseNotification, severity: "success" },
                    React.createElement(PeekTypography, { variant: "body1" }, notification))))));
};
const ViewerLayout = ({ children, refetch }) => {
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(NotificationProvider, null,
            React.createElement(LoaderProvider, null,
                React.createElement(ErrorProvider, null,
                    React.createElement(RefetchProvider, { contextRefetch: refetch },
                        React.createElement(ContactProvider, null,
                            React.createElement(Layout, null, children))))))));
};

export { ViewerLayout, ViewerLayout as default };
